import { render } from "./DeleteAccountPage.vue?vue&type=template&id=dc9c39ba&scoped=true"
import script from "./DeleteAccountPage.vue?vue&type=script&lang=js"
export * from "./DeleteAccountPage.vue?vue&type=script&lang=js"

import "./DeleteAccountPage.vue?vue&type=style&index=0&id=dc9c39ba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc9c39ba"]])

export default __exports__